/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import axios from "axios";

const USER_URL = "api/user";

export function HeaderMenu({ layoutProps }) {
  const location = useLocation();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  // Admin (role_id 2) or Super Admin (role_id 1).
  const [isAdminOrSuperAdmin, setIsAdminOrSuperAdmin] = useState(false);
  // TODO: temporary quick fix - Super Admin, Admin, and Branch Head can access
  // Customize Stream Message. Replace with proper role/permission gating.
  const [canAccessStreamCustomization, setCanAccessStreamCustomization] = useState(false);
  // TODO: temporary quick fix - Super Admin, Admin, Branch Head, and Instructor
  // can access School Programs (instructors read-only, to take attendance), and
  // the first three School Information. Replace with proper role/permission gating.
  const [canAccessSchoolPrograms, setCanAccessSchoolPrograms] = useState(false);
  const [canAccessSchoolInformation, setCanAccessSchoolInformation] = useState(false);
  // Featured Courses: same audience as Customize Stream Message (Super Admin,
  // Admin, Branch Head), matching what the server accepts on
  // api/branch-course/featured/:branchId.
  const [canAccessFeaturedCourses, setCanAccessFeaturedCourses] = useState(false);
  // Enrollment Pause Dashboard: Super Admin, Admin, and Branch Head can view.
  const [canAccessPauseDashboard, setCanAccessPauseDashboard] = useState(false);
  // Check-in: Super Admin only while the feature is trialled in UAT. Widen to
  // Admin and Branch Head (`isAdminOrBranchHead`) when it opens to everyone.
  const [canAccessCheckIn, setCanAccessCheckIn] = useState(false);

  const getMenuItemActive = (url) => {
    return checkIsActive(location, url) ? "menu-item-active" : "";
  };

  const user_id = useSelector(
    (state) => state.auth.user && state.auth.user[0].user_id,
    shallowEqual
  );
  const access = useSelector((state) => state.auth.access, shallowEqual);

  useEffect(() => {
    const fetchUserRoles = async () => {
      if (user_id) {
        try {
          const res_roles = await axios.get(USER_URL + "/role/" + user_id);
          const roles = res_roles.data;
          const isSuperAdminRole = roles.some(
            (role) => role.role_id === 1 || role.role_name === "Super Admin"
          );
          setIsSuperAdmin(isSuperAdminRole);
          setIsAdminOrSuperAdmin(
            roles.some((role) => role.role_id === 1 || role.role_id === 2)
          );
          const isAdminOrBranchHead = roles.some(
            (role) =>
              role.role_id === 1 ||
              role.role_id === 2 ||
              role.role_id === 4 ||
              role.role_name === "Super Admin" ||
              role.role_name === "Admin" ||
              role.role_name === "Branch Head"
          );
          setCanAccessStreamCustomization(isAdminOrBranchHead);
          setCanAccessSchoolPrograms(
            isAdminOrBranchHead ||
              roles.some(
                (role) => role.role_id === 5 || role.role_name === "Instructor"
              )
          );
          setCanAccessSchoolInformation(isAdminOrBranchHead);
          setCanAccessFeaturedCourses(isAdminOrBranchHead);
          setCanAccessPauseDashboard(isAdminOrBranchHead);
          setCanAccessCheckIn(isSuperAdminRole);
        } catch (error) {
          console.log(error);
        }
      }
    };
    fetchUserRoles();
  }, [user_id]);

  return (
    <div
      id="kt_header_menu"
      className={`header-menu header-menu-left header-menu-mobile ${layoutProps.ktMenuClasses}`}
      {...layoutProps.headerMenuAttributes}
    >
      {/*begin::Header Nav*/}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/dashboard"
          )}`}
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="menu-text">Dashboard</span>
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        {access["batches"] != undefined && (
          <li
            data-menu-toggle={layoutProps.menuDesktopToggle}
            aria-haspopup="true"
            className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive(
              "/google-material"
            )}`}
          >
            <NavLink className="menu-link menu-toggle" to="/google-material">
              <span className="menu-text">Batches</span>
              <i className="menu-arrow"></i>
            </NavLink>
            <div className="menu-submenu menu-submenu-classic menu-submenu-left">
              <ul className="menu-subnav">
                <li
                  className={`menu-item menu-item-rel ${getMenuItemActive(
                    "/batches"
                  )}`}
                >
                  <NavLink className="menu-link" to="/batches">
                    <span className="menu-text">Regular Classes</span>
                    {layoutProps.rootArrowEnabled && (
                      <i className="menu-arrow" />
                    )}
                  </NavLink>
                </li>
                <li
                  className={`menu-item menu-item-rel ${getMenuItemActive(
                    "/camps"
                  )}`}
                >
                  <NavLink className="menu-link" to="/camps">
                    <span className="menu-text">Camps</span>
                    {layoutProps.rootArrowEnabled && (
                      <i className="menu-arrow" />
                    )}
                  </NavLink>
                </li>
                {
                  canAccessSchoolPrograms && (

                    <li
                    className={`menu-item menu-item-rel ${getMenuItemActive(
                      "/school-programs"
                      )}`}
                      >
                  <NavLink className="menu-link" to="/school-programs">
                    <span className="menu-text">School Programs</span>
                    {layoutProps.rootArrowEnabled && (
                      <i className="menu-arrow" />
                    )}
                  </NavLink>
                </li>
                )}
              </ul>
            </div>
          </li>
        )}
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        {(access["branch_course"] != undefined ||
          access["branch-maintenance"] != undefined) && (
          <li
            data-menu-toggle={layoutProps.menuDesktopToggle}
            aria-haspopup="true"
            className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive(
              "/google-material"
            )}`}
          >
            <NavLink className="menu-link menu-toggle" to="/google-material">
              <span className="menu-text">Admin Options</span>
              <i className="menu-arrow"></i>
            </NavLink>
            <div className="menu-submenu menu-submenu-classic menu-submenu-left">
              <ul className="menu-subnav">
                <li
                  className={`menu-item menu-item-rel ${getMenuItemActive(
                    "/branch-course"
                  )}`}
                >
                  <NavLink className="menu-link" to="/branch-course">
                    <span className="menu-text">Branch Streams</span>
                    {layoutProps.rootArrowEnabled && (
                      <i className="menu-arrow" />
                    )}
                  </NavLink>
                </li>
                {canAccessStreamCustomization && (
                  <li
                    className={`menu-item menu-item-rel ${getMenuItemActive(
                      "/branch-course-customization"
                    )}`}
                  >
                    <NavLink className="menu-link" to="/branch-course-customization">
                      <span className="menu-text">Customize Stream Message</span>
                      {layoutProps.rootArrowEnabled && (
                        <i className="menu-arrow" />
                      )}
                    </NavLink>
                  </li>
                )}
                {canAccessFeaturedCourses && (
                  <li
                    className={`menu-item menu-item-rel ${getMenuItemActive(
                      "/featured-courses"
                    )}`}
                  >
                    <NavLink className="menu-link" to="/featured-courses">
                      <span className="menu-text">Featured Courses</span>
                      {layoutProps.rootArrowEnabled && (
                        <i className="menu-arrow" />
                      )}
                    </NavLink>
                  </li>
                )}
                <li
                  className={`menu-item menu-item-rel ${getMenuItemActive(
                    "/branch-maintenance"
                  )}`}
                >
                  <NavLink className="menu-link" to="/branch-maintenance">
                    <span className="menu-text">Branch Maintenance</span>
                    {layoutProps.rootArrowEnabled && (
                      <i className="menu-arrow" />
                    )}
                  </NavLink>
                </li>
                <li
                  className={`menu-item menu-item-rel ${getMenuItemActive(
                    "/staff"
                  )}`}
                >
                  <NavLink className="menu-link" to="/users">
                    <span className="menu-text">Staff</span>
                    {layoutProps.rootArrowEnabled && (
                      <i className="menu-arrow" />
                    )}
                  </NavLink>
                </li>
                {(access["reporting"] != undefined ||
                  [8219, 7661, 6724].includes(user_id)) && (
                  <li
                    className={`menu-item menu-item-rel ${getMenuItemActive(
                      "/reporting"
                    )}`}
                  >
                    <NavLink className="menu-link" to="/reporting">
                      <span className="menu-text">Analytics</span>
                      {layoutProps.rootArrowEnabled && (
                        <i className="menu-arrow" />
                      )}
                    </NavLink>
                  </li>
                )}
                {access["customer_leads"] !== undefined && (
                  <li
                    className={`menu-item menu-item-rel ${getMenuItemActive(
                      "/customer-leads"
                    )}`}
                  >
                    <NavLink className="menu-link" to="/customer-leads">
                      <span className="menu-text">Customer Leads</span>
                      {layoutProps.rootArrowEnabled && (
                        <i className="menu-arrow" />
                      )}
                    </NavLink>
                  </li>
                )}
                {(access["web_transactions"] !== undefined ||
                  [8219].includes(user_id)) && (
                  <li
                    className={`menu-item menu-item-rel ${getMenuItemActive(
                      "/web-transactions"
                    )}`}
                  >
                    <NavLink className="menu-link" to="/web-transactions">
                      <span className="menu-text">Web Transactions</span>
                      {layoutProps.rootArrowEnabled && (
                        <i className="menu-arrow" />
                      )}
                    </NavLink>
                  </li>
                )}
                <li
                  className={`menu-item menu-item-rel ${getMenuItemActive(
                    "/emails"
                  )}`}
                >
                  <NavLink className="menu-link" to="/emails">
                    <span className="menu-text">Email</span>
                    {layoutProps.rootArrowEnabled && (
                      <i className="menu-arrow" />
                    )}
                  </NavLink>
                </li>
                <li
                  className={`menu-item menu-item-rel ${getMenuItemActive(
                    "/student-family-branch"
                  )}`}
                >
                  <NavLink className="menu-link" to="/student-family-branch">
                    <span className="menu-text">Add Student Family To Branch</span>
                    {layoutProps.rootArrowEnabled && (
                      <i className="menu-arrow" />
                    )}
                  </NavLink>
                </li>

                {canAccessSchoolInformation && (
                  <li
                    className={`menu-item menu-item-rel ${getMenuItemActive(
                      "/school-information"
                    )}`}
                  >
                    <NavLink className="menu-link" to="/school-information">
                      <span className="menu-text">School Information</span>
                      {layoutProps.rootArrowEnabled && (
                        <i className="menu-arrow" />
                      )}
                    </NavLink>
                  </li>
                )}
                {canAccessPauseDashboard && (
                  <li
                    className={`menu-item menu-item-rel ${getMenuItemActive(
                      "/enrollment-pause-dashboard"
                    )}`}
                  >
                    <NavLink
                      className="menu-link"
                      to="/enrollment-pause-dashboard"
                    >
                      <span className="menu-text">Enrollment Pauses</span>
                      {layoutProps.rootArrowEnabled && (
                        <i className="menu-arrow" />
                      )}
                    </NavLink>
                  </li>
                )}
                {canAccessCheckIn && (
                  <li
                    className={`menu-item menu-item-rel ${getMenuItemActive(
                      "/check-in"
                    )}`}
                  >
                    <NavLink className="menu-link" to="/check-in">
                      <span className="menu-text">Check-in</span>
                      {layoutProps.rootArrowEnabled && (
                        <i className="menu-arrow" />
                      )}
                    </NavLink>
                  </li>
                )}
                {isSuperAdmin && (
                  <li
                    className={`menu-item menu-item-rel ${getMenuItemActive(
                      "/bulk-pay-upload"
                    )}`}
                  >
                    <NavLink className="menu-link" to="/bulk-pay-upload">
                      <span className="menu-text">Record Bulk Payments</span>
                      {layoutProps.rootArrowEnabled && (
                        <i className="menu-arrow" />
                      )}
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}

        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        {access["coupons"] != undefined && (
          <li
            className={`menu-item menu-item-rel ${getMenuItemActive(
              "/coupons"
            )}`}
          >
            <NavLink className="menu-link" to="/coupons">
              <span className="menu-text">Coupons</span>
              {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
            </NavLink>
          </li>
        )}

        {access["events"] != undefined && (
          <li
            className={`menu-item menu-item-rel ${getMenuItemActive(
              "/events"
            )}`}
          >
            <NavLink className="menu-link" to="/events">
              <span className="menu-text">Events</span>
              {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
            </NavLink>
          </li>
        )}

        {/*end::1 Level*/}
      </ul>
      {/*end::Header Nav*/}
    </div>
  );
}
